import React, { useEffect, useReducer } from "react";

import Tabs from "components/tabs";
import { reducer, initialState } from "../reducer";

import {
    HeaderSection,
    ServingColumn,
    ServingSection,
    SubSectionSpaced,
    SubSection,
    SubSectionInfo,
    SubSectionSpacedInfo,
    SubSectionTable,
    SubSectionTableRow,
    SubSectionTableData,
} from "components/attributes/panels/components/read-only-sections";
import { readOnlyValue } from "components/attributes/lib/attribute-data";

import "../../../panels/components/read-only-sections/read-only-sections.scss";

const ReadOnlyDrugPanel = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const panelInfo = state.panels[state.selectedPanel];

    useEffect(() => {
        if (!props.value || !props.value.panels) {
            return;
        }

        dispatch({ type: "SAVE_PANELS", panels: props.value.panels || [], isDirty: false });
    }, []);

    const changeTab = (tabIndex) => {
        dispatch({ type: "SET_PANEL_INDEX", selectedPanel: tabIndex });
    };

    if (!panelInfo) {
        return null;
    }

    return (
        <div className="container">
            <Tabs
                tabs={state.panels}
                reportSelectedTab={changeTab}
                selectedTab={state.selectedPanel}
                readOnly={true}
            />
            <div className="panel read-only">
                <HeaderSection label="Drug Facts" />

                <ServingSection>
                    <ServingColumn>
                        <div>{panelInfo.servingText}</div>
                    </ServingColumn>
                </ServingSection>

                <SubSectionSpaced
                    leftLabel="Active ingredient"
                    rightLabel="Purpose"
                >
                    {panelInfo.activeIngredients.map(({ key, name, measurement, noteMark, purpose }) => {
                        return (
                            <SubSectionSpacedInfo key={key}>
                                <div>
                                    <b>{readOnlyValue(noteMark, "DropdownPickList")}</b>
                                    {name.text} {measurement.value}
                                    {measurement.uom.text}
                                </div>
                                <div>{purpose}</div>
                            </SubSectionSpacedInfo>
                        );
                    })}
                </SubSectionSpaced>

                <SubSection label="Uses">
                    {panelInfo.uses.map(({ key, text, bullets }) => {
                        return (
                            <SubSectionInfo
                                key={key}
                                label={text}
                                bold
                            >
                                {readOnlyValue(bullets, "FeatureBullet")}
                            </SubSectionInfo>
                        );
                    })}
                </SubSection>

                <SubSection label="Warnings">
                    {panelInfo.warnings.map(({ key, text, bullets }) => {
                        return (
                            <SubSectionInfo
                                key={key}
                                label={text}
                                bold
                            >
                                {readOnlyValue(bullets, "FeatureBullet")}
                            </SubSectionInfo>
                        );
                    })}
                </SubSection>

                <SubSection label="Directions">{readOnlyValue(panelInfo.directions, "FeatureBullet")}</SubSection>

                <SubSectionSpaced
                    leftLabel="User groups directions"
                    separatorVariant="thick"
                >
                    {panelInfo.userGroups.map(({ key, userGroup, directions }) => {
                        return (
                            <SubSectionTable key={key}>
                                <SubSectionTableRow>
                                    <SubSectionTableData>{userGroup}</SubSectionTableData>
                                    <SubSectionTableData>{directions}</SubSectionTableData>
                                </SubSectionTableRow>
                            </SubSectionTable>
                        );
                    })}
                </SubSectionSpaced>

                <SubSection
                    label="Footnotes"
                    separatorVariant="none"
                >
                    {panelInfo.footnotes.items.map(({ text, noteMark }, index) => {
                        return (
                            <div
                                key={index}
                                className="footnote"
                            >
                                <div className="input-group">
                                    <b>{readOnlyValue(noteMark, "DropdownPickList")}</b>
                                    {text}
                                </div>
                            </div>
                        );
                    })}
                </SubSection>

                <SubSection
                    label="Other information"
                    separatorVariant="none"
                    headerVariant="small"
                >
                    {readOnlyValue(panelInfo.otherInformation, "FeatureBullet")}
                </SubSection>

                <SubSection
                    label="Inactive ingredients"
                    separatorVariant="none"
                    headerVariant="small"
                >
                    {readOnlyValue(panelInfo.inactiveIngredients, "FeatureBullet")}
                </SubSection>

                <SubSection
                    label="Comments"
                    separatorVariant="none"
                >
                    <div>{panelInfo.comments}</div>
                </SubSection>

                <SubSection
                    label="Additional details"
                    separatorVariant="none"
                >
                    <div>{panelInfo.additionalDetails}</div>
                </SubSection>
            </div>
        </div>
    );
};

export default ReadOnlyDrugPanel;
